<template>
    <div>
        <div class="sm:hidden ml-24">
            <select name="" id="">
                <option value="">Course Intro and Happiness</option>
                <option value="">Devaluating Happiness</option>
                <option value="">Chasing Superiority</option>
                <option value="">Being overly control seeking</option>
            </select>
        </div>
        <div class="flex">
            <div class="sm:w-3/12 hidden sm:block bg-orange-100">
                <div>
                    <button class="text-black bg-orange-200 rounded-2xl p-1 ml-4 mt-4 flex"><svg aria-hidden="true" focusable="false" class="svgicon w-3 mt-2 icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                        </path></svg><span>Back to Course</span></button>
                </div>
                <h3 class="text-2xl font-bold mt-4 ml-4">A life of Happiness and Fulfillment</h3>
                <div class="bg-gray-300 ml-4 mr-4 mt-4 h-1 rounded">
                    <div class="bg-ff9811 w-0 h-full">
                    </div>
                </div>
                <h3 class="text-xxs opacity-50 ml-4 mt-4">0% Complete</h3>
                <h3 class="text-xxs opacity-50 ml-4">Last activity on May 28, 2019</h3>
                <hr class="ml-4 mr-4 mt-4">
                <h3 class="mt-4 ml-4 font-bold text-base">Introduction</h3>
                <div class="flex items-center mt-4">
                    <h3 class="ml-4 opacity-50">&#9660;</h3>
                    <h3 class="text-xxs w-56">Course intro and happiness mea... <span class="opacity-80">4 Topics</span></h3>
                    <input class="checkbox-round" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">Welcome to the course</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">Genesis to the course</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">Measuring happiness</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">Introducing the Seven Deadly...</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <h3 class="mt-4 ml-4 font-bold text-base">HAPPINESS SINS</h3>
                <div class="flex items-center mt-4">
                    <h3 class="ml-4 opacity-50">&#9660;</h3>
                    <h3 class="text-xxs w-56">Sin1: Devaluating Happiness<span class="opacity-80">2 Topics</span></h3>
                    <input class="checkbox-round" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">The Fundamental Happiness P...</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">Prioritize but don't pursue H...</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <div class="flex items-center mt-4">
                    <h3 class="ml-4 opacity-50">&#9660;</h3>
                    <h3 class="text-xxs w-56">Sin2: Chasing Superiority<span class="opacity-80">2 Topics</span></h3>
                    <input class="checkbox-round" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="opacity-50 fas mr-2 fa-times-circle"></i>
                    <h3 class="ml-1 w-56 opacity-50">Effects of chasing superiority...</h3>
                    <input class="checkbox-round mr-2" type="checkbox">
                </div>
                <!-- <div class="flex items-center ml-8 mt-4">
                    <i class="fa-solid fa-memo"></i>
                    <h3 class="ml-1 w-56 opacity-50">Flow is discovered</h3>
                    <input class="checkbox-round" type="checkbox">
                </div>
                <div class="flex items-center ml-8 mt-4">
                    <i class="fa-solid fa-memo"></i>
                    <h3 class="ml-1 w-56 opacity-50">Characteristics of flow</h3>
                    <input class="checkbox-round" type="checkbox">
                </div>
                <div class="flex items-center mt-4">
                    <h3 class="ml-4 opacity-80">&#9660;</h3>
                    <h3 class="text-xxs w-56"><span class="text-blue-500">Sin3: Being Overly Control Seeking</span><span class="opacity-80">2 Topics</span></h3>
                    <input class="checkbox-round" type="checkbox">
                </div> -->
            </div>
            <div class="sm:w-3/6 ">
                <h3 class="text-2xl mt-8 ml-16 sm:ml-12">1 / 4</h3>
                <h3 class="text-2xl ml-16 sm:ml-12 xl:mr-56">What year is your student expected to graduate from high school?</h3>
                <h3 class="ml-16 sm:ml-12 xl:mr-64">Understanding your relationship to the student will help us suggest the most suitable test prep option.</h3>
                <div class="sm:flex mt-12 ml-8">
                    <div class="border rounded flex flex-col items-center p-3">
                        <h3>In love!</h3>
                    </div>
                    <div class="border rounded flex flex-col items-center p-3 ml-4">
                       
                        <h3>Happy</h3>
                    </div>
                    <div class="border rounded flex flex-col items-center p-3 ml-4">
                       
                        <h3>Ok</h3>
                    </div>
                    <div class="border rounded flex flex-col items-center p-3 ml-4">
                        <h3>Sad</h3>
                    </div>
                    <div class="border rounded flex flex-col items-center p-3 ml-4">
                        <h3>Angry</h3>
                    </div>
                </div>
                <div class="flex mt-24 ml-24">
                    <div class="flex items-center">
                       <h3 class="border rounded-50p w-8 p-1 opacity-50 flex justify-center">&lt;</h3>
                       <h3 class="opacity-50 ml-4">Back</h3>
                    </div>
                    <div class="flex items-center sm:ml-24">
                        <h3 class="text-blue-500">Next</h3>
                        <h3 class="border rounded-50p ml-4 border-blue-500 text-blue-500 w-8 p-1 flex justify-center">&gt;</h3>
                    </div>
                </div>
            </div>
            <div class="sm:w-3/12 hidden sm:block border">
                <div class="sm:flex mt-4">
                    <div class="flex p-2 border-b-4 ml-4 border-blue-500">
                        <h3 class="font-bold">DISCUSSION</h3>
                    </div>
                    <div class="p-2 ml-4">
                        <h3 class="opacity-50 font-bold">VIEWERS</h3>
                    </div>
                </div>
                <div class="bg-orange-100">
                    <button class="border bg-white font-bold mt-4 ml-4 pt-1 pb-1 pl-16 pr-16 whitespace-no-wrap mr-4">Follow Discussion</button>
                    <div class="flex mt-5">
                        <div class="ml-4">
                        </div>
                        <div class="ml-4 mr-5">
                            <h3 class="opacity-50">Bruce Wayne . 3 days ago</h3>
                            <p class="leading-normal text-xxs"><span class="font-bold">@Barbara Gordon,</span> could you please check in with Amari, learn more about how things are going and if there are issues with training? Thanks!</p>
                        </div>
                    </div>
                    <div class="flex mt-5">
                        <div class="ml-4">
                        </div>
                        <div class="ml-4 mr-5">
                            <h3 class="opacity-50">Barbara Gordon . 2 days ago</h3>
                            <p class="leading-normal text-xxs"><span class="font-bold">@Bruce Wayne,</span> Amari has some personal issues resulting in two days of missed training. This left some big holes in knowledge of the job and</p>
                        </div>
                    </div>
                    <div class="flex mt-5">
                        <div class="ml-4">
                        </div>
                        <div class="ml-4 mr-5">
                            <h3 class="opacity-50">Barbara Gordon . 2 days ago</h3>
                            <p class="leading-normal text-xxs"><span class="font-bold">@Bruce Wayne,</span> Amari has some personal issues resulting in two days of missed training. This left some big holes in knowledge of the job and workload, and she didn't know if or when there would be time to make up the missed training. I talked with the</p>
                        </div>
                    </div>
                    <div class="flex mt-5">
                        <div class="ml-4">
                        </div>
                        <div class="ml-4 mr-5">
                            <h3 class="opacity-50">Barbara Gordon . 2 days ago</h3>
                            <p class="leading-normal text-xxs"><span class="font-bold">@Bruce Wayne,</span> Amari has some personal issues resulting in two days of missed training. This left some big holes in knowledge of the job and workload, and she didn't know if or when there would be time to make up the missed training. I talked with the trainer on how better to handle this</p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <button class="bg-blue-500 rounded absolute p-1 ml-13rem mt-4 text-white">Submit</button>
                        <textarea class="border ml-4 w-64 h-24"  placeholder="Add a comment..."></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name: "WellbeingAnswers",
        data(){
            return{
                
            }
        }
    }
</script>
<style scoped>
.svgicon{
    transform: rotateZ(90deg);
}
.checkbox-round {
    width: 1.3em;
    height: 1.3em;
    background-color: white;
    border-radius: 50%;
    vertical-align: middle;
    border: 1px solid #ddd;
    appearance: none;
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
    opacity: 1;
    z-index:auto;
}


</style>